import type { Product } from '../types/product';

/**
 * Returns a new array of products sorted by name according to provided sort option.
 * - 'a-z': ascending A-Z with numeric-leading names first.
 * - 'z-a': descending Z-A with numeric-leading names last.
 * - 'default': returns input array reference (no clone / no sort).
 * Comparison is case-insensitive and numeric-aware (e.g., Item 2 before Item 10).
 */
export function sortProductsByName(
  products: Product[] | undefined | null,
  sort: 'default' | 'a-z' | 'z-a'
): Product[] | undefined | null {
  if (!products || !products.length || sort === 'default') return products;

  const direction = sort === 'a-z' ? 1 : -1;

  return [...products].sort((a: Product, b: Product) => {
    const nameA = (a.name || '').trim();
    const nameB = (b.name || '').trim();

    const startsNumA = /^[0-9]/.test(nameA);
    const startsNumB = /^[0-9]/.test(nameB);

    if (startsNumA !== startsNumB) {
      const numOrder = direction === 1 ? -1 : 1; // numbers first ascending, last descending
      return startsNumA ? numOrder : -numOrder;
    }

    const cmp = nameA.localeCompare(nameB, 'en', { sensitivity: 'base', numeric: true });
    if (cmp !== 0) return cmp * direction;

    return String(a.id).localeCompare(String(b.id), 'en', { numeric: true }) * direction;
  });
}
